/**
 * Base path for the Rovo assist "resources" icon endpoint. The endpoint
 * resolves a connector `source` slug to a hosted icon image, e.g.
 * `/gateway/api/assist/rovo/v1/resources/icon/microsoft_onedrive`.
 */
const ASSIST_RESOURCES_ICON_BASE = '/gateway/api/assist/rovo/v1/resources/icon';

/**
 * @internal Implementation detail of `useRovoConfigStore`. Do **not** import
 * this from anywhere other than
 * `src/services/hooks/useRovoConfigStore.tsx` — it is intentionally not part
 * of the package's public API (no `package.json` `exports` subpath).
 *
 * Builds the icon URL for a connector from its `source` slug, using the same
 * Rovo assist "resources" icon endpoint that the assistance-service response
 * points `iconUrl` at on the non-rovo-config (FG-off) chat path. This keeps
 * the connector icons rendering identically to how chat currently displays
 * them (a plain `<img src={iconUrl} />`), without this package needing to
 * resolve the static `RovoLogo` component icons to URLs.
 *
 * TODO RAOC-23: replace this endpoint-derived URL with a real per-config
 * icon lookup from the static configs catalogue in this package, so that
 * icons are resolved locally rather than via a network round-trip. Tracked
 * for follow-up in the project tracker. Will require downstream code changes.
 */
export const getIconUrlForSource = (source: string): string =>
	source ? `${ASSIST_RESOURCES_ICON_BASE}/${source}` : '';
